/* Photography is presentational; only the chosen canonical size is submitted. */
(() => {
  const initialized = new WeakSet();
  const initialize = () => document.querySelectorAll('[data-denim-shop], [data-product-grid-section]').forEach(section => {
    if (initialized.has(section)) return;
    initialized.add(section);
    const toggle = section.querySelector('[data-photo-toggle]');
    const viewButtons = [...section.querySelectorAll('[data-photo-view]')];
    const photos = [...section.querySelectorAll('[data-card-photo]')];
    if (toggle && photos.length) {
      toggle.hidden = false;
      viewButtons.forEach(button => button.addEventListener('click', () => {
        const view = button.dataset.photoView;
        if (!['full', 'pants'].includes(view)) return;
        photos.forEach(photo => { photo.hidden = photo.dataset.cardPhoto !== view; });
        viewButtons.forEach(control => control.setAttribute('aria-pressed', String(control === button)));
        const status = section.querySelector('[data-photo-status]');
        if (status) status.textContent = view === 'pants' ? 'Showing pants close-up photos.' : 'Showing full fit photos.';
      }));
    }
    section.querySelectorAll('[data-card-form]').forEach(form => {
      const sizes = [...form.querySelectorAll('[data-card-size]')];
      const button = form.querySelector('[data-card-add]');
      const card = form.closest('[data-product-card]');
      if (!sizes.length || !button || !card) return;
      const pending = form.dataset.setupPending === 'true';
      const soldOut = form.dataset.soldOut === 'true';
      const sync = () => {
        const option = sizes.find(size => size.checked);
        const available = Boolean(option?.value && option.dataset.available === 'true') && !pending;
        button.disabled = !available;
        if (option?.dataset.price) card.querySelector('[data-card-price]').textContent = option.dataset.price;
        const status = form.querySelector('[data-card-status]');
        if (status) status.textContent = pending ? 'Coming soon' : soldOut ? 'Sold out' : option?.value ? (available ? `${option.dataset.size} selected` : 'This size is sold out') : 'Choose your size';
        if (option?.value) card.querySelectorAll('[data-card-link]').forEach(link => {
          const url = new URL(link.href, location.href);
          url.searchParams.set('variant', option.value);
          link.href = url.href;
        });
        return available;
      };
      sizes.forEach(size => size.addEventListener('change', sync));
      form.addEventListener('submit', event => {
        if (!sync()) { event.preventDefault(); sizes.find(size => !size.disabled)?.focus(); }
      });
      window.addEventListener('pageshow', sync);
      sync();
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
